<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-food</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.cmWeeklyMenu') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
    </v-toolbar>
  <v-layout wrap v-if="content">
    <v-flex xs12
      v-if="cmDviewcontentContentID"
    >
      <v-select
        v-model="content.WeeklyMenuContentID"
        item-text="Name"
        item-value="ID"
        :items="cmDviewcontentContentID"
        :label="$t('dtouch.workspace.weeklyMenu.contentID', locale)"
        outlined
        @change="handleChangeIsModified"
        hide-details
        style="margin-bottom: 10px;"
      />
    </v-flex>
    <v-flex xs12>
      <color-picker-item
        :value="content.WeeklyMenuWeekColor1"
        label="Semana color 1"
        :onChange="handleChangeWeekColor1"
        borderRadius="20px 0 0 0"
      />
    </v-flex>
    <v-flex xs12>
      <color-picker-item
        :value="content.WeeklyMenuWeekColor2"
        label="Semana color 2"
        :onChange="handleChangeWeekColor2"
        borderRadius="0"
      />
    </v-flex>
    <v-flex xs12>
      <color-picker-item
        :value="content.WeeklyMenuColor1"
        label="Color 1"
        :onChange="handleChangeColor1"
        borderRadius="0"
      />
    </v-flex>
    <v-flex xs12>
      <color-picker-item
        :value="content.WeeklyMenuColor2"
        label="Color 2"
        :onChange="handleChangeColor2"
        borderRadius="0 0 20px 0"
      />
    </v-flex>
  </v-layout>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ColorPickerItem from '@/components/common-components/ColorPickerItem'
import api from '@/services/api'
export default {
  components: {
    ColorPickerItem,
  },
  props: {
    content: {
      type: Object,
      required: true
    },
  },
  data: () => ({
    cmDviewcontentContentID: [],
  }),
  computed: {
    ...mapState('app',['collapseContent', 'locale']),
    enterpriseID () {
      return this.$store.state.app.enterpriseID
    }
  },
  mounted () {
    this.prepareContent()
  },
  methods: {
    prepareContent () {
      api.getAll(`contents/${this.enterpriseID}/weekly-menu-content-id`, true, 0, 1000, '')
        .then(response => {
          this.cmDviewcontentContentID = response
        })
    },
    handleChangeIsModified () {
      this.$store.state.app.isModified = true
    },
    handleChangeWeekColor1 (v) {
      this.content.WeeklyMenuWeekColor1 = v
      this.handleChangeIsModified()
    },
    handleChangeWeekColor2 (v) {
      this.content.WeeklyMenuWeekColor2 = v
      this.handleChangeIsModified()
    },
    handleChangeColor1 (v) {
      this.content.WeeklyMenuColor1 = v
      this.handleChangeIsModified()
    },
    handleChangeColor2 (v) {
      this.content.WeeklyMenuColor2 = v
      this.handleChangeIsModified()
    },
  }
}
</script>

<style scoped>
</style>

